import React from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { CurrencyFormatter } from '../CurrencyFormatter';
import * as styles from './CrossedPrice.style';
import { DiscountSoldesLabel, PromoLabel } from '../Label';
import { tooltipLink, tooltipText, tooltipTitle, tooltipUrl } from './contants';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { HtmlTooltip } from './customComponents';
export const CrossedPrice = ({ discount, originPrice, sales, tooltipSlug, display, isNew = false, isNegociated = false, }) => {
    const TooltipComponent = () => {
        return (React.createElement(Box, { sx: styles.toolTipPopper },
            React.createElement(Box, { sx: styles.toolTipPopperTitle }, tooltipTitle),
            React.createElement(Box, null, tooltipText),
            React.createElement(Box, { component: "a", href: tooltipUrl, sx: styles.tooltipLink },
                tooltipLink,
                " ",
                React.createElement(ArrowForwardIcon, { fontSize: "small" }))));
    };
    const TooltipPrice = () => {
        return (React.createElement(React.Fragment, null,
            React.createElement(HtmlTooltip, { title: React.createElement(TooltipComponent, null), arrow: true },
                React.createElement(InfoOutlinedIcon, { sx: styles.toolTip }))));
    };
    return (React.createElement(React.Fragment, null,
        discount > 0 && (React.createElement(Stack, { direction: "row", justifyContent: "center" },
            React.createElement(Box, { sx: styles.crossedPriceDisplay(display) },
                React.createElement(Box, { component: "span", "data-qa": "pricing-type", sx: styles.priceType(isNew) }, isNew ? 'Prix Neuf' : isNegociated ? 'Prix négocié' : 'Prix conseillé'),
                React.createElement(Box, { component: "span", sx: styles.displayLabel },
                    React.createElement(Box, { sx: styles.productPriceBefore(true) },
                        React.createElement(CurrencyFormatter, { "data-qa": "originPrice", amount: originPrice })),
                    React.createElement(Box, { sx: styles.displayLabel },
                        !isNegociated && React.createElement(PromoLabel, { discount: discount }),
                        tooltipSlug && React.createElement(TooltipPrice, null)))))),
        sales > 0 && (React.createElement(Box, { sx: styles.crossedPriceDisplay(display) },
            React.createElement(Box, { component: "span", "data-qa": "originPrice", sx: styles.productPriceBefore(true) },
                React.createElement(CurrencyFormatter, { amount: originPrice })),
            React.createElement(Box, { sx: styles.displayLabel },
                React.createElement(DiscountSoldesLabel, { discountText: `${sales}%`, labelText: "soldes", backgroundTextColor: "lightBlue100", backgroundDiscountColor: "lightBlue600" }),
                tooltipSlug && React.createElement(TooltipPrice, null))))));
};
